import React from 'react';

// BMC Helix Innovation Studio – Config Check Page (testing only)
const HELIX_IFRAME_SRC = 'https://techcentral-demo-is.onbmc.com/helix/index.html#/com.bmc.arsys.rx.innovationstudio/view/edit/com.helix.demoops-agents:config%20check%20page';

const InnovationSuite = () => (
  <div
    style={{
      width: '100%',
      height: 'calc(100vh - 120px)',
      minHeight: '400px',
      margin: 0,
      padding: 0,
    }}
  >
    <iframe
      id="helixFrame"
      title="BMC Helix View – Config Check Page"
      src={HELIX_IFRAME_SRC}
      loading="lazy"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
      allow="clipboard-write"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
      }}
    />
  </div>
);

export default InnovationSuite;
